import {SidebarSponsors as SponsorsComponent} from '@github-ui/code-view-sidebar/components/SidebarSponsors'
import {useCombinedSidebarPayload} from '@github-ui/code-view-sidebar/use-combined-sidebar-payload'

interface Props {
  ownerLogin: string
  repoName: string
}

export function SidebarSponsors({ownerLogin, repoName}: Props) {
  const {sponsors} = useCombinedSidebarPayload(ownerLogin, repoName)
  if (!sponsors) return null
  return <SponsorsComponent {...sponsors} />
}
